import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "ic-play",
  "use": "ic-play-usage",
  "viewBox": "0 0 29 29",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 29 29\" id=\"ic-play\">\n    <g fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M0 0h28.8v28.8H0z\" />\n        <path d=\"M3 3h24v24H3z\" />\n        <path fill=\"#4A4A4A\" d=\"M15 5C9.48 5 5 9.48 5 15s4.48 10 10 10 10-4.48 10-10S20.52 5 15 5z\" />\n        <path fill=\"#FFF\" d=\"M13 19.5v-9l6 4.5z\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol